/**
 * Behaviour for the product card (`snippets/product-card.liquid`).
 *
 * The card no longer flips into a variant/quantity picker. Quick-add now adds
 * the first/selected variant straight to the cart — on desktop via the button
 * revealed on hover, on touch via the button rendered beneath the card.
 *
 * The per-product data that only Liquid can render is passed in as options from
 * the template:
 *   x-data="ProductCard({
 *     selectedVariantId: {{ variant_id }},
 *     variantAvailability: { 123: true, 456: false },
 *   })"
 *
 * @param {object}  opts
 * @param {number}  opts.selectedVariantId   Variant added by quick-add.
 * @param {Object<number, boolean>} opts.variantAvailability  id → available.
 */
export default function ProductCard({
  selectedVariantId,
  variantAvailability = {},
} = {}) {
  return {
    selectedVariantId,
    variantAvailability,

    get selectedAvailable() {
      return !!this.variantAvailability[this.selectedVariantId];
    },

    addToCart() {
      if (!this.selectedAvailable) return;
      this.$store.cart.addCartItem(this.selectedVariantId, 1, {});
      this.$store.cartOpen = true;
    },
  };
}
